export default function () {
  const rentPlanTypes = [
    {
      id: 1,
      name: '个人租赁方案',
    },
    {
      id: 2,
      name: '企业租赁方案',
    },

  ]

  const abnormalTableColums = [
    {
      name: 'rentPlanName',
      align: 'center',
      columnProps: {
        label: '租赁方案名称',
        prop: 'rentPlanName',
        minWidth: 120,
      },
    },
    {
      name: 'bindItemNames',
      align: 'center',
      columnProps: {
        label: '已绑定维保项目名称',
        prop: 'bindItemNames',
        minWidth: 120,
      },
    },
    {
      name: 'itemName',
      align: 'center',
      columnProps: {
        label: '新维保项目名称',
        prop: 'itemName',
        minWidth: 120,
      },
    },
  ]


  const radioArr = [
    {
      label: 0,
      text: '覆盖更新',
    },
    {
      label: 1,
      text: '添加',
    },
    {
      label: 2,
      text: '不处理',
    },
  ]


  return {
    rentPlanTypes,
    abnormalTableColums,
    radioArr,
  }
}
